export const sliders = {
  init() {
    require('./product-selected');
    require('./product-slider');
    require('./feature-slider');
    require('./article-slider');
    require('./article-listing');
	require('./trustbar-slider');
	require('./cart-slider');
	require('./category-promo-slider');
	require('./sub-navigation');
	require('./product-bundle-page-slider');

    // IOS 13.1.3 Flickity Fix
    let touchingCarousel = false;
    let touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY,
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  },
}



// WEBPACK FOOTER //
// ./scripts/components/sliders/index.js